import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginMaster } from '../lib/master-api';

const MasterLoginPage = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await loginMaster(email, password);
      navigate('/master');
    } catch (err) {
      setError(err.response?.data?.error || '로그인에 실패했습니다');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'radial-gradient(ellipse at top, #1a1f2e 0%, #0b0f1a 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 20,
      position: 'relative',
      overflow: 'hidden',
    }}>
      {/* Decorative gold accent */}
      <div style={{
        position: 'absolute',
        top: '-20%',
        right: '-10%',
        width: 500,
        height: 500,
        background: 'radial-gradient(circle, rgba(191,155,48,0.18) 0%, transparent 60%)',
        borderRadius: '50%',
        pointerEvents: 'none',
      }} />
      <div style={{
        position: 'absolute',
        bottom: '-20%',
        left: '-10%',
        width: 500,
        height: 500,
        background: 'radial-gradient(circle, rgba(191,155,48,0.1) 0%, transparent 60%)',
        borderRadius: '50%',
        pointerEvents: 'none',
      }} />

      <div style={{
        position: 'relative',
        width: '100%',
        maxWidth: 420,
        background: 'rgba(15, 20, 32, 0.85)',
        border: '1px solid rgba(191,155,48,0.35)',
        borderRadius: 20,
        padding: '44px 40px',
        boxShadow: '0 20px 80px rgba(0,0,0,0.6), 0 0 0 1px rgba(191,155,48,0.1)',
        backdropFilter: 'blur(16px)',
      }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{
            width: 56,
            height: 56,
            background: 'linear-gradient(135deg, #BF9B30 0%, #806413 100%)',
            borderRadius: 14,
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: 16,
            boxShadow: '0 8px 24px rgba(191,155,48,0.35)',
          }}>
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round">
              <path d="M12 2l3 7h7l-5.5 4.5L18 21l-6-4-6 4 1.5-7.5L2 9h7z" />
            </svg>
          </div>
          <div style={{
            fontSize: '0.7rem',
            fontWeight: 700,
            color: '#BF9B30',
            letterSpacing: 2,
            textTransform: 'uppercase',
            marginBottom: 4,
          }}>
            Master Console
          </div>
          <h1 style={{
            fontSize: '1.4rem',
            fontWeight: 800,
            color: '#fff',
            letterSpacing: '-0.5px',
          }}>
            마스터 관리자
          </h1>
          <p style={{
            marginTop: 6,
            fontSize: '0.82rem',
            color: 'rgba(255,255,255,0.5)',
          }}>
            플랫폼 운영을 위한 관리 콘솔입니다
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 16 }}>
            <label style={{
              display: 'block',
              fontSize: '0.78rem',
              fontWeight: 600,
              color: 'rgba(255,255,255,0.7)',
              marginBottom: 6,
            }}>
              이메일
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
              placeholder="admin@qrorder.kr"
              style={inputStyle}
            />
          </div>

          <div style={{ marginBottom: 20 }}>
            <label style={{
              display: 'block',
              fontSize: '0.78rem',
              fontWeight: 600,
              color: 'rgba(255,255,255,0.7)',
              marginBottom: 6,
            }}>
              비밀번호
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
              placeholder="••••••••"
              style={inputStyle}
            />
          </div>

          {error && (
            <div style={{
              padding: '10px 14px',
              background: 'rgba(240,68,82,0.12)',
              border: '1px solid rgba(240,68,82,0.3)',
              borderRadius: 10,
              color: '#ff8993',
              fontSize: '0.82rem',
              marginBottom: 16,
            }}>
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              padding: '13px 16px',
              background: loading
                ? 'rgba(191,155,48,0.6)'
                : 'linear-gradient(135deg, #BF9B30 0%, #A07D1A 100%)',
              color: '#fff',
              borderRadius: 10,
              fontSize: '0.92rem',
              fontWeight: 700,
              border: 'none',
              cursor: loading ? 'default' : 'pointer',
              boxShadow: '0 8px 24px rgba(191,155,48,0.3)',
              transition: 'transform 0.1s',
            }}
          >
            {loading ? '로그인 중...' : '로그인'}
          </button>
        </form>

        <div style={{
          marginTop: 24,
          paddingTop: 20,
          borderTop: '1px solid rgba(255,255,255,0.08)',
          textAlign: 'center',
          fontSize: '0.75rem',
          color: 'rgba(255,255,255,0.4)',
        }}>
          매장 관리자이신가요?{' '}
          <a href="/login" style={{ color: '#BF9B30', fontWeight: 600 }}>매장 로그인</a>
        </div>
      </div>
    </div>
  );
};

const inputStyle = {
  width: '100%',
  padding: '11px 14px',
  background: 'rgba(255,255,255,0.05)',
  border: '1px solid rgba(255,255,255,0.1)',
  borderRadius: 10,
  color: '#fff',
  fontSize: '0.9rem',
  fontFamily: 'inherit',
  transition: 'all 0.2s',
};

export default MasterLoginPage;
